import React from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { SCROLLABLE_CONTAINER } from '../itemIds';

export interface ScrollableContainerProps {
  height?: string;
  overflow?: string;
}

export type ScrollableContainerDefinition = ItemDefinition<
  typeof SCROLLABLE_CONTAINER,
  ScrollableContainerProps
>;

export class ScrollableContainer extends Item<
  typeof SCROLLABLE_CONTAINER,
  ScrollableContainerProps
> {
  protected render({
    height,
    overflow,
    children
  }: RenderProps<ScrollableContainerProps>) {
    return (
      <div
        style={{
          height,
          overflow
        }}
      >
        {children}
      </div>
    );
  }
}

registry[SCROLLABLE_CONTAINER] = ScrollableContainer;
